import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/utils/analytics';
import { capture } from '@/lib/analytics/posthog';
import { readShareArrival } from '@/lib/utm';

// The INBOUND half of tracked sharing. Our share links have carried
// utm_source=share for a while; until now nothing read them back, so "did
// sharing bring anyone?" had no row to count — the exact failure the portfolio
// plays list calls "often built and unfed". A share click measures
// enthusiasm; share_visit is the denominator that says whether the people
// being sent are worth anything.
//
// Fires once per page LOAD, not per route change: one arrival is one event,
// and the utm params stay in the address bar while the visitor clicks around.
// Module scope rather than a ref, so a remount cannot double-count it.
let shareArrivalFired = false;

function captureShareArrival(): void {
    if (shareArrivalFired) return;
    shareArrivalFired = true;
    // Fires NOTHING unless the URL actually carries our own utm_source — an
    // "unknown" bucket that swallowed organic traffic would be worse than no
    // row at all.
    const arrival = readShareArrival(window.location.search);
    if (!arrival) return;
    capture('share_visit', arrival);
}

export function usePageTracking(): void {
    const location = useLocation();

    useEffect(() => {
        const url = window.location.origin + location.pathname + location.search + location.hash;
        trackPageView(url);
        captureShareArrival();
    }, [location.pathname, location.search, location.hash]);
}
